// import { FaUserCircle } from 'react-icons/fa';
import {
  Box,
  Flex,
  Icon,
  Link,
  Menu,
  MenuButton,
  useColorModeValue,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { FaAlignLeft, FaAlignRight, FaUser, FaUserTie } from 'react-icons/fa';
import { MdDashboard } from 'react-icons/md';
import { connect } from 'react-redux';
import NavItem from '../navitem';

function Sidebar(props) {
  const { user: loggedInUser } = props;
  const [navSize, changeNavSize] = useState('large');

  return (
    <Flex
      mr="5"
      display={{ base: 'none', md: 'flex' }}
      pos="sticky"
      boxShadow="0 4px 12px 0 rgba(0, 0, 0, 0.05)"
      w={navSize === 'small' ? '45px' : '85px'}
      flexDir="column"
      justifyContent="space-between"
      bg={useColorModeValue('brand.red', 'gray.800')}
      color={useColorModeValue('white', 'black')}
    >
      <Flex
        flexDir="column"
        w="100%"
        alignItems={navSize === 'small' ? 'center' : 'flex-start'}
        as="nav"
        fontSize="12"
      >
        <Menu placement="right">
          <Link
            color={useColorModeValue('brand.white', 'brand.black')}
            mt={2}
            p={2}
            href
            onClick={() => {
              if (navSize === 'small') changeNavSize('large');
              else changeNavSize('small');
            }}
            _hover={{
              textDecor: 'none',
              backgroundColor: 'brand.green',
            }}
            w={navSize === 'large' && '100%'}
          >
            <MenuButton w="100%">
              <Icon
                as={navSize === 'small' ? FaAlignRight : FaAlignLeft}
                boxSize="8"
                color={useColorModeValue('brand.white', 'brand.black')}
              />
              <Box display={navSize === 'small' ? 'none' : 'flex'}>
                Collapse Menu
              </Box>
            </MenuButton>
          </Link>
        </Menu>
 
        {/* <NavItem
          navSize={navSize}
          icon={MdDashboard}
          title="Contribution Dashboard"
          link="/contribution-dashboard"
        /> */}

        <NavItem
          navSize={navSize}
          icon={FaUserTie}
          title="Prospect Management"
          link="/"
        />
        {loggedInUser && loggedInUser.userRole !== 'Member' ? (
          <NavItem
            navSize={navSize}
            icon={FaUser}
            title="User Management"
            link="/users"
          />
        ) : null}
      </Flex>
    </Flex>
  );
}

const stateMapper = (state) => ({
  user: state.auth?.user,
});

export default connect(stateMapper)(Sidebar);
